export default __webpack_public_path__ + "static/media/Izmir-Light.e15a5c80.woff2";